import { lazy } from "react"
import { Route, Routes, useLocation } from "react-router-dom"
import { useWindowDimensions } from "mobile/hooks"
import { useNavigation } from "modules/navigation"
import styled from "styled-components"

import { ModalProvider } from "./components/Modal/ModalOverlay/Context"

const PageLayout = styled.main`
  width: 100vw;
  margin-top: 50px;
  height: ${({ windowHeight }) => {
    if (typeof windowHeight === "number") {
      return `calc(${windowHeight}px - 50px)`
    } else {
      return `calc(${windowHeight} - 50px)`
    }
  }};
`

const LandingPage = lazy(() => import("./view/LandingPage"))
const NewOrder = lazy(() => import("./view/NewOrder"))
const CustomerInfo = lazy(() => import("./view/NewOrder/CustomerInfo"))
const ScanGo = lazy(() => import("./view/NewOrder/ScanGo"))
const PaymentInfo = lazy(() => import("./view/NewOrder/PaymentInfo"))
const ProceedPayment = lazy(() => import("./view/NewOrder/ProceedPayment"))
const OrderComplete = lazy(() => import("./view/NewOrder/OrderComplete"))
const ScooterDelivery = lazy(() => import("./view/ScooterDelivery/ScooterDelivery"))
const DeliverySuccess = lazy(() => import("./view/ScooterDelivery/DeliverySuccess"))
const OrdersList = lazy(() => import("./view/OrdersList"))
const OrderDetail = lazy(() => import("./view/OrderDetail"))
const ScanVin = lazy(() => import("./view/ScooterDelivery/ScanVin"))
const ClientNewOrder = lazy(() => import("./view/customer/NewOrder"))
const ClientCustomerInfo = lazy(() => import("./view/customer/NewOrder/CustomerInfo"))
const ClientUploadDocument = lazy(() => import("./view/customer/NewOrder/UploadDocument"))
const ClientViewCustomerInfo = lazy(() => import("./view/customer/NewOrder/ViewCustomerProfile"))
const ClientPaymentInfo = lazy(() => import("./view/customer/NewOrder/PaymentInfo"))
const ClientCreditCardBinding = lazy(() => import("./view/customer/NewOrder/CreditCardBinding"))
const ClientCreditCardBindingResult = lazy(() => import("./view/customer/NewOrder/CreditCardBindingResult"))
const ClientCreditCardList = lazy(() => import("./view/customer/NewOrder/CreditCardList"))
const ClientSignContract = lazy(() => import("./view/customer/NewOrder/SignContract"))
const ClientPaymentComplete = lazy(() => import("./view/customer/NewOrder/PaymentComplete"))
const ClientRedirectPage = lazy(() => import("./view/customer/NewOrder/RedirectPage"))
const ErrorPage = lazy(() => import("./view/ErrorPage"))

const App = () => {
  const { pathname } = useLocation()
  const { height } = useWindowDimensions()
  const { previousUrl } = useNavigation()
  const isMatchCustomerInfo = previousUrl.match(/^\/new\/([^/]+)\/1/)
  const orderId = isMatchCustomerInfo ? isMatchCustomerInfo[1] : undefined

  return (
    <ModalProvider>
      <PageLayout pathname={pathname} windowHeight={height}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/new" element={<NewOrder backFromOrderId={orderId} />} />
          <Route path="/new/:orderNo/1" element={<CustomerInfo />} />
          <Route path="/new/:orderNo/2" element={<ScanGo />} />
          <Route path="/new/:orderNo/3" element={<PaymentInfo />} />
          <Route path="/new/:orderNo/4" element={<ProceedPayment />} />
          <Route path="/new/:orderNo/complete" element={<OrderComplete />} />
          <Route path="/pending-orders" element={<OrdersList />} />
          <Route path="/all-orders" element={<OrdersList />} />
          <Route path="/all-order/:orderNo" element={<OrderDetail />} />
          <Route path="/scooter-delivery" element={<OrdersList />} />
          <Route path="/scooter-delivery/:orderNo" element={<ScooterDelivery />} />
          <Route path="/scooter-delivery/:orderNo/scan" element={<ScanVin />} />
          <Route path="/scooter-delivery/:orderNo/success" element={<DeliverySuccess />} />
          <Route path="/customer/redirect/:orderQrCodeId" element={<ClientRedirectPage />} />
          <Route path="/customer/home/:orderNo" element={<ClientNewOrder />} />
          <Route path="/customer/new/:orderNo/1" element={<ClientCustomerInfo />} />
          <Route path="/customer/new/:orderNo/1/upload" element={<ClientUploadDocument />} />
          <Route path="/customer/new/:orderNo/1/view" element={<ClientViewCustomerInfo />} />
          <Route path="/customer/new/:orderNo/2" element={<ClientPaymentInfo />} />
          <Route path="/customer/new/:orderNo/2/bind-card" element={<ClientCreditCardBinding />} />
          <Route path="/customer/new/:orderNo/2/bind-card/list" element={<ClientCreditCardList />} />
          <Route path="/customer/new/:orderNo/2/bind-card/result" element={<ClientCreditCardBindingResult />} />
          <Route path="/customer/new/:orderNo/3" element={<ClientSignContract />} />
          <Route path="/customer/new/:orderNo/complete" element={<ClientPaymentComplete />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </PageLayout>
    </ModalProvider>
  )
}

export default App
